import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { QueryClient, QueryClientProvider } from 'react-query';

import { LeadType } from '@utils/enums';

import CtaButtonModalBody from '../CtaButtonModalBody';
import LeadCaptureModalBody from '../LeadCaptureModalBody';
import { MarketingCopyProps } from '../index';

export enum ModalType {
  CustomUrl = 'custom_url',
  LeadCapture = 'lead_capture',
  StandardOffer = 'standard_offer',
}

const queryClient = new QueryClient();

const MarketingCopy = ({
  articleId,
  buttonText,
  briefingGuid,
  customUrl,
  disclosure,
  header,
  leadType = LeadType.MarketingModal,
  modalType,
  offerLink,
  shareGuid,
  subtitle,
  title,
  trackingProps,
  unlockContent,
}: MarketingCopyProps): JSX.Element => {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex w-full flex-wrap content-center items-center justify-center px-24 py-72 sm:px-64 sm:py-64 md:justify-between md:px-48 md:pb-80 md:pt-80">
        <header className="mb-16 flex w-full flex-col text-left sm:mb-32 md:mb-0 md:w-1/2">
          {header && (
            <div className="font-suisse-intl text-overline-lg text-primary-magenta">{header}</div>
          )}
          <h1 className="mb-8 mt-0 font-suisse-works text-headline-md text-white sm:text-headline-lg md:text-headline-xl">
            {title}
          </h1>
          <p className="my-0 font-suisse-intl-mono text-overline-lg text-white">
            {ReactHtmlParser(subtitle)}
          </p>
          {disclosure && modalType === ModalType.LeadCapture && (
            <p className="mb-0 mt-8 text-left font-suisse-screen text-disclosure-sm text-white">
              {disclosure}
            </p>
          )}
        </header>

        <div className="w-full md:w-[380px]">
          {/* Render correct type of modal based on modal type */}
          {modalType === ModalType.LeadCapture && (
            <LeadCaptureModalBody
              articleId={articleId}
              buttonText={buttonText}
              briefingGuid={briefingGuid}
              disclosure={disclosure}
              offerLink={offerLink}
              shareGuid={shareGuid}
              trackingProps={trackingProps}
              leadType={leadType}
              unlockContent={unlockContent}
            />
          )}
          {(modalType === ModalType.CustomUrl || modalType === ModalType.StandardOffer) && (
            <CtaButtonModalBody
              buttonText={buttonText}
              disclosure={disclosure}
              destinationUrl={modalType === ModalType.CustomUrl ? customUrl : offerLink}
            />
          )}
        </div>
      </div>
    </QueryClientProvider>
  );
};

export default MarketingCopy;
